export const CART_TOP_REF_UPDATE = "CART_TOP_REF_UPDATE";
export const CART_BOTTOM_REF_UPDATE = "CART_BOTTOM_REF_UPDATE";
export const CART_TYPE_UPDATE = "CART_TYPE_UPDATE";

export const cartTopRefUpdate = ref => {
  return async dispatch => {
    dispatch({ type: CART_TOP_REF_UPDATE, payload: ref });
  };
};

export const cartBottomRefUpdate = ref => {
  return async dispatch => {
    dispatch({ type: CART_BOTTOM_REF_UPDATE, payload: ref });
  };
};

export const cartTypeUpdate = type => {
  return async dispatch => {
    dispatch({ type: CART_TYPE_UPDATE, payload: type });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/cartPosition.js